import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import classes from "./index.module.css";
import ServiceItemMasterFilter from "./ServiceItemMasterFilter";
import ServiceItemMasterSummary from "./ServiceItemMasterSummary";
import AddServiceItem from "./addServiceItem/index";

const ServiceItems = () => {
  const [showAddServiceItem, setShowAddServiceItem] = useState(false);
  const [serviceItemData, setServiceItemData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();

  const addServiceItem = useCallback((isEdit = false) => {
    if (isEdit) {
      setServiceItemData(reportRef.current.getCurrentRowData());
    }
    setShowAddServiceItem(true);
  }, []);
  const applyFilterHandler = useCallback((params, filterStates) => {
    setRefreshData(false);
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);

  const closeServiceItemAc = useCallback(() => {
    setShowAddServiceItem(false);
    setServiceItemData(null);
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  const debouncecloseServiceItemAc = _.debounce(closeServiceItemAc, 200);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        setRefreshData(true);
        return;
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (altKey && key === "n") {
        return addServiceItem();
      }
    },
    [addServiceItem, currentRowData]
  );

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addServiceItem(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addServiceItem, currentRowData]);

  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddServiceItem &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [
    currentComponent,
    listener,
    onColumnShow,
    onFilterShow,
    showAddServiceItem,
  ]);

  return (
    <div className={classes["service-item-report-container"]}>
      <Reports
        identifier="serviceItemMaster"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filterParams={filterParams}
        filterStates={filterStates}
        filters={
          <ServiceItemMasterFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            refreshData={refreshData}
            applyFilters={applyFilterHandler}
            onFilterShow={onFilterShow}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <ServiceItemMasterSummary
        refreshData={() => {
          setRefreshData(true);
        }}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addServiceItem();
        }}
      />
      <Autocomplete
        show={showAddServiceItem}
        height="50%"
        width="90%"
        closeAutoComplete={debouncecloseServiceItemAc}
      >
        <AddServiceItem
          serviceItemData={serviceItemData}
          onEscape={debouncecloseServiceItemAc}
          onSaveServiceItem={() => {
            debouncecloseServiceItemAc();
            setRefreshData(true);
          }}
        />
      </Autocomplete>
    </div>
  );
};

export default ServiceItems;
